class ShopByCategories {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.carousel = document.getElementById(`shopByCategoriesCarousel-${sectionId}`);
    this.progressFill = document.getElementById(`shopByCategoriesProgress-${sectionId}`);
    this.prevBtn = document.querySelector(`.shop-by-categories__nav--prev[data-section="${sectionId}"]`);
    this.nextBtn = document.querySelector(`.shop-by-categories__nav--next[data-section="${sectionId}"]`);
    
    this.currentSlide = 0;
    this.slidesToShow = this.getSlidesToShow();
    this.slidesToScroll = this.getSlidesToScroll();
    this.totalSlides = this.carousel ? this.carousel.children.length : 0;
    
    // Add isScrolling flag to prevent conflict between manual and user scrolling
    this.isScrolling = false;
    
    if (this.totalSlides > 0) {
      this.init();
    }
  }

  getSlidesToShow() {
    const width = window.innerWidth;
    if (width < 768) return 2;
    if (width < 1024) return 3;
    return 4;
  }

  getSlidesToScroll() {
    const width = window.innerWidth;
    if (width < 768) return 2;
    if (width < 1024) return 3;
    return 4;
  }

  init() {
    this.updateButtons();
    this.updateProgress();
    
    // Event listeners for navigation buttons
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.prev();
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.next();
      });
    }
    
    // Scroll event for progress bar with throttling
    let scrollTimeout;
    this.carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => this.handleScroll(), 50);
    });
    
    // Resize handling
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => this.handleResize(), 250);
    });
  }

  prev() {
    if (this.currentSlide > 0) {
      this.currentSlide = Math.max(0, this.currentSlide - this.slidesToScroll);
      this.scrollToSlide();
    }
  }

  next() {
    const maxSlide = Math.max(0, this.totalSlides - this.slidesToShow);
    if (this.currentSlide < maxSlide) {
      this.currentSlide = Math.min(maxSlide, this.currentSlide + this.slidesToScroll);
      this.scrollToSlide();
    }
  }

  scrollToSlide() {
    const item = this.carousel.children[0];
    if (!item) return;
    
    const itemWidth = item.offsetWidth;
    const computedStyle = window.getComputedStyle(this.carousel);
    const gap = parseFloat(computedStyle.gap) || 32;
    const scrollAmount = this.currentSlide * (itemWidth + gap);
    
    this.isScrolling = true;
    
    this.carousel.scrollTo({
      left: scrollAmount,
      behavior: 'smooth'
    });
    
    // Reset the flag after scroll completes
    setTimeout(() => {
      this.isScrolling = false;
    }, 500);
    
    this.updateButtons();
  }

  handleScroll() {
    // Don't update if we're programmatically scrolling
    if (this.isScrolling) return;
    
    const item = this.carousel.children[0];
    if (!item) return;
    
    const itemWidth = item.offsetWidth;
    const computedStyle = window.getComputedStyle(this.carousel);
    const gap = parseFloat(computedStyle.gap) || 32;
    const scrollLeft = this.carousel.scrollLeft;
    const itemWidthWithGap = itemWidth + gap;
    
    // Calculate current slide based on scroll position
    this.currentSlide = Math.round(scrollLeft / itemWidthWithGap);
    this.updateButtons();
    this.updateProgress();
  }

  updateButtons() {
    const maxSlide = Math.max(0, this.totalSlides - this.slidesToShow);
    
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentSlide <= 0;
      this.prevBtn.style.cursor = this.prevBtn.disabled ? 'not-allowed' : 'pointer';
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentSlide >= maxSlide;
      this.nextBtn.style.cursor = this.nextBtn.disabled ? 'not-allowed' : 'pointer';
    }
  }

  updateProgress() {
    if (!this.progressFill) return;
    
    const progressBarWidth = (this.slidesToShow / this.totalSlides) * 100;
    const maxSlide = Math.max(1, this.totalSlides - this.slidesToShow);
    const progressPosition = (this.currentSlide / maxSlide) * (100 - progressBarWidth);
    
    this.progressFill.style.width = `${Math.min(100, Math.max(10, progressBarWidth))}%`;
    this.progressFill.style.marginLeft = `${Math.min(100 - progressBarWidth, Math.max(0, progressPosition))}%`;
  }

  handleResize() {
    const oldSlidesToShow = this.slidesToShow;
    const oldSlidesToScroll = this.slidesToScroll;
    
    this.slidesToShow = this.getSlidesToShow();
    this.slidesToScroll = this.getSlidesToScroll();
    
    if (oldSlidesToShow !== this.slidesToShow) {
      const maxSlide = Math.max(0, this.totalSlides - this.slidesToShow);
      this.currentSlide = Math.min(this.currentSlide, maxSlide);
      this.scrollToSlide();
    }
    
    this.updateButtons();
    this.updateProgress();
  }
}

// Initialize all shop by categories sections
function initializeShopByCategories() {
  const sections = document.querySelectorAll('.shop-by-categories');
  
  sections.forEach(section => {
    const classList = Array.from(section.classList);
    const sectionClass = classList.find(cls => cls.startsWith('shop-by-categories-'));
    
    if (sectionClass) {
      const sectionId = sectionClass.replace('shop-by-categories-', '');
      new ShopByCategories(sectionId);
    }
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeShopByCategories);
} else {
  initializeShopByCategories();
}

// Handle theme editor changes
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.target.querySelector('.shop-by-categories');
    if (section) {
      const classList = Array.from(section.classList);
      const sectionClass = classList.find(cls => cls.startsWith('shop-by-categories-'));
      
      if (sectionClass) {
        const sectionId = sectionClass.replace('shop-by-categories-', '');
        new ShopByCategories(sectionId);
      }
    }
  });
}